import React from "react";
import { Loader2, ArrowLeft, ChevronRight } from "lucide-react";

interface ActionButtonsProps {
  onBack: () => void;
  onSubmit: () => void;
  isLoading: boolean;
  isFormValid?: boolean;
  backLabel?: string;
  submitLabel?: string;
  loadingLabel?: string;
  className?: string;
  buttonStyle?: "default" | "instructor";
}

const ActionButtons = ({
  onBack,
  onSubmit,
  isLoading,
  isFormValid = true,
  backLabel = "Volver",
  submitLabel = "Completar registro",
  loadingLabel = "Registrando...",
  className = "",
  buttonStyle = "default",
}: ActionButtonsProps) => {
  if (buttonStyle === "instructor") {
    return (
      <div className={`flex flex-col sm:flex-row justify-between items-center gap-4 ${className}`}>
        <button
          type="button"
          onClick={onBack}
          className="flex items-center justify-center gap-2 w-full sm:w-auto px-4 py-2.5 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 transition-all duration-200 active:scale-[0.98]"
        >
          <ArrowLeft className="w-4 h-4" />
          {backLabel}
        </button>
        <button
          type="button"
          onClick={onSubmit}
          disabled={isLoading || !isFormValid}
          className={`w-full sm:w-auto flex justify-center items-center gap-2 py-2.5 px-5 border border-transparent rounded-lg shadow-md text-sm font-medium text-white transition-all duration-300 relative z-10 cursor-pointer active:scale-[0.98] hover:shadow-lg ${
            isLoading || !isFormValid
              ? "bg-gray-400 cursor-not-allowed opacity-70"
              : "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
          }`}
        >
          {isLoading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>{loadingLabel}</span>
            </>
          ) : (
            <>
              <span>{submitLabel}</span>
              <ChevronRight className="w-4 h-4" />
            </>
          )}
        </button>
      </div>
    );
  }

  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <button
        type="button"
        onClick={onBack}
        className="flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 transition-all duration-200 active:scale-[0.98]"
      >
        <ArrowLeft className="w-4 h-4" />
        {backLabel}
      </button>
      <button
        type="button"
        onClick={onSubmit}
        disabled={isLoading || !isFormValid}
        className={`flex-1 flex justify-center items-center gap-2 py-2.5 px-5 border border-transparent rounded-lg shadow-md text-sm font-medium text-white transition-all duration-300 relative z-10 cursor-pointer active:scale-[0.98] hover:shadow-lg ${
          isLoading || !isFormValid
            ? "bg-gray-400 cursor-not-allowed opacity-70"
            : "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
        }`}
      >
        {isLoading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            <span>{loadingLabel}</span>
          </>
        ) : (
          <>
            <span>{submitLabel}</span>
            <ChevronRight className="w-4 h-4" />
          </>
        )}
      </button>
    </div>
  );
};

export default ActionButtons; 